import { render, staticRenderFns } from "./VipBuy.vue?vue&type=template&id=dd371126"
import script from "./VipBuy.vue?vue&type=script&lang=js"
export * from "./VipBuy.vue?vue&type=script&lang=js"
import style0 from "./VipBuy.vue?vue&type=style&index=0&id=dd371126&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports